var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ConfigureComponentBase } from '../../../shared/configure-component-base';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { ConfigureViewType } from '../designer/shared/configure-view-type';
import { GraphReziser } from './graph-reziser';
import { Size as guiSize } from '@flexem/fc-gui';
import { SimulateRemoteGuiContext } from '../../../shared/gui/simulate-remote-gui-context';
import { AppConsts } from '../../../shared/AppConsts';
var ConfigureSimulationComponent = /** @class */ (function (_super) {
    __extends(ConfigureSimulationComponent, _super);
    function ConfigureSimulationComponent(injector, configureViewService, modalRef, elementRef, configPermissionServiceProxy) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.configureViewService = configureViewService;
        _this.modalRef = modalRef;
        _this.elementRef = elementRef;
        _this.configPermissionServiceProxy = configPermissionServiceProxy;
        _this.isFullScreen = false;
        _this.graphWidth = 800.0;
        _this.graphHeight = 450.0;
        _this.graphResizer = new GraphReziser(_this.graphWidth, _this.graphHeight);
        _this.isPcView = true;
        _this.guiErrorContainerHeight = 450.0;
        _this.size = new guiSize(_this.graphWidth, _this.graphHeight);
        return _this;
    }
    ConfigureSimulationComponent.prototype.ngOnInit = function () {
        this.configureId = this.args.configureId;
        this.isPcView = this.args.viewType !== ConfigureViewType.Mobile;
        this.contextArgs = {
            views: this.args.views,
            mainViewIndex: this.args.mainViewIndex,
            ownedPermissions: [],
            variables: this.args.variables
        };
        this.initConfigureViewStttings();
    };
    ConfigureSimulationComponent.prototype.initConfigureViewStttings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var webConfigureViewPromise, mobileConfigureViewPromise, configurePermissionsPromise, results, permissions, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        abp.ui.setBusy(this.elementRef.nativeElement);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        webConfigureViewPromise = this.configureViewService.getConfigureViewSetting(this.configureId, ConfigureViewType.Web.valueOf()).toPromise();
                        mobileConfigureViewPromise = this.configureViewService.getConfigureViewSetting(this.configureId, ConfigureViewType.Mobile.valueOf()).toPromise();
                        configurePermissionsPromise = this.configPermissionServiceProxy.getConfigurePermissions(this.configureId).toPromise();
                        return [4 /*yield*/, Promise.all([webConfigureViewPromise, mobileConfigureViewPromise, configurePermissionsPromise])];
                    case 2:
                        results = _a.sent();
                        this.webConfigureViewSetting = results[0];
                        this.mobileConfigureViewSetting = results[1];
                        permissions = results[2].items;
                        this.configurePermissions = permissions.map(function (item) {
                            return { 'label': item.name, value: item };
                        });
                        this.selectedConfigurePermissions = permissions.map(function (item) {
                            return item;
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        abp.log.error('Init configureViewStttings failed.' + e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        abp.ui.clearBusy(this.elementRef.nativeElement);
                        return [7 /*endfinally*/];
                    case 5:
                        if (this.isPcView) {
                            this.simulatePc();
                        }
                        else {
                            this.simulateMobile();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigureSimulationComponent.prototype.closeModal = function () {
        this.modalRef.hide();
    };
    ConfigureSimulationComponent.prototype.refresh = function () {
        this.setOwnedPermissions();
        this.reInitGuiContext(this.contextArgs);
    };
    ConfigureSimulationComponent.prototype.simulatePc = function () {
        this.isPcView = true;
        this.displayMode = 'Web';
        this.resizeGuiAndContainerSize();
        this.contextArgs.mainViewIndex = this.args.mainViewIndex;
        this.setOwnedPermissions();
        this.reInitGuiContext(this.contextArgs);
    };
    ConfigureSimulationComponent.prototype.simulateMobile = function () {
        this.isPcView = false;
        this.displayMode = 'Mobile';
        this.resizeGuiAndContainerSize();
        this.contextArgs.mainViewIndex = this.args.mobileMainViewIndex;
        this.setOwnedPermissions();
        this.reInitGuiContext(this.contextArgs);
    };
    ConfigureSimulationComponent.prototype.resizeGuiAndContainerSize = function () {
        var result;
        if (this.isPcView) {
            result = this.graphResizer.resize(this.webConfigureViewSetting.defaultWidth, this.webConfigureViewSetting.defaultHeight, true);
        }
        else {
            result = this.graphResizer.resize(this.mobileConfigureViewSetting.defaultWidth, this.mobileConfigureViewSetting.defaultHeight, true);
        }
        this.setGuiAndContainerSize(result);
    };
    ConfigureSimulationComponent.prototype.reInitGuiContext = function (args) {
        if (this.guiContext !== undefined) {
            this.guiContext = this.guiContext.replace(args.views, args.mainViewIndex, args.ownedPermissions);
        }
        else {
            this.guiContext = new SimulateRemoteGuiContext(this.injector, args);
        }
    };
    ConfigureSimulationComponent.prototype.setOwnedPermissions = function () {
        this.contextArgs.ownedPermissions = _.map(this.selectedConfigurePermissions, function (item) {
            return item.tag;
        });
    };
    ConfigureSimulationComponent.prototype.simulateFullScreen = function () {
        var fullScreenGraphResizer = new GraphReziser($('body').width(), $('body').height());
        var result;
        if (this.isPcView) {
            result = fullScreenGraphResizer.resize(this.webConfigureViewSetting.defaultWidth, this.webConfigureViewSetting.defaultHeight, true);
        }
        else {
            result = fullScreenGraphResizer.resize(this.mobileConfigureViewSetting.defaultWidth, this.mobileConfigureViewSetting.defaultHeight, true);
        }
        this.setGuiAndContainerSize(result);
    };
    ConfigureSimulationComponent.prototype.setGuiAndContainerSize = function (size) {
        $(this.container.nativeElement).css({ 'width': size.width + "px", 'height': size.height + "px" });
        this.size = new guiSize(size.width - 2, size.height - 2);
        this.guiErrorContainerHeight = size.height;
    };
    ConfigureSimulationComponent.prototype.toggleFullScreen = function () {
        this.isFullScreen = !this.isFullScreen;
    };
    ConfigureSimulationComponent.prototype.enterOrLeaveFullScreen = function (val) {
        if (val) {
            this.simulateFullScreen();
        }
        else {
            this.resizeGuiAndContainerSize();
        }
    };
    ConfigureSimulationComponent.prototype.onGuiLoaded = function () {
    };
    ConfigureSimulationComponent.prototype.onGuiLoadFailed = function (error) {
        this.guiError = this.ls(AppConsts.localization.deviceLocalizationSourceName, 'GuiLoadFailed');
        abp.log.error(error);
    };
    ConfigureSimulationComponent.prototype.publish = function () {
        abp.event.trigger('designer.try-release');
    };
    __decorate([
        ViewChild('configureContainer', { static: false })
    ], ConfigureSimulationComponent.prototype, "container", void 0);
    ConfigureSimulationComponent = __decorate([
        Component({
            selector: 'configure-simulation',
            template: "<div class=\"configure-simulation-modal-container fe-modal-container\" bs-modal-drag> <div class=\"modal-header fe-modal-header simulation-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"ConfigureSimulate\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"closeModal()\">×</div> </div> <div class=\"fe-modal-middle\"> <div class=\"row toolbar margin-top-10\"> <div class=\"col-9\"> <span class=\"permission-span\">{{lc('Permission')}}:</span> <p-multiSelect [options]=\"configurePermissions\" [defaultLabel]=\"l('Choose')\" [selectedItemsLabel]=\"'{0}' + l('ItemSelected')\" [(ngModel)]=\"selectedConfigurePermissions\"></p-multiSelect> <a (click)=\"refresh()\" class=\"refresh fcloud-refresh-normal\"></a> <a (click)=\"simulatePc()\" class=\"pc-screen fcloud-web-normal\" [class.active]=\"isPcView\"></a> <a (click)=\"simulateMobile()\" class=\"mobile-screen fcloud-mobile-normal\" [class.active]=\"!isPcView\"></a> <a (click)=\"toggleFullScreen()\" class=\"full-screen fcloud-full-screen-normal\"></a> </div> <div class=\"col-3\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save pull-right publish\" (click)=\"publish()\"> {{lc(\"Publish\")}} </button> </div> </div> <fc-full-screen [(isFullScreen)]=\"isFullScreen\" (stateChanged)=\"enterOrLeaveFullScreen($event)\"> <span header-bar>{{lc('ConfigureSimulate')}}</span> <div class=\"outer-container\" full-screen-content [class.normal]=\"!isFullScreen\"> <div id=\"graph-container\" #configureContainer> <fc-gui *ngIf=\"!guiError\" [displayMode]=\"displayMode\" [context]=\"guiContext\" [size]=\"size\" (loaded)=\"onGuiLoaded()\" (loadFailed)=\"onGuiLoadFailed($event)\"></fc-gui> <p *ngIf=\"guiError\" class=\"gui-error-tip\" [style.line-height.px]=\"guiErrorContainerHeight\">{{guiError}}</p> </div> </div> </fc-full-screen> </div> <div class=\"fe-modal-footer clearfix\"> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one float-right\" (click)=\"closeModal()\"> {{l(\"Close\")}} </button> </div> </div> ",
            styles: [".configure-simulation-modal-container { width: 100%; .refresh, .pc-screen, .mobile-screen, .full-screen { display: inline-block; position: relative; top: -4px; text-underline: none; border: none; padding: 0; margin-left: 6px; cursor: pointer; font-size: 25px; } .fe-modal-middle{ input[type=text]{ padding-left: 15px; } } a.refresh:hover::before { content: \"\\e993\"; color: #7f939f; } a.refresh:active::before { content: \"\\e991\"; color: #3695ff; } a.pc-screen:hover::before { content: \"\\e998\"; color: #7f939f; } a.pc-screen:active::before { content: \"\\e996\"; color: #3695ff; } a.pc-screen.active::before{ content: \"\\e996\"; color: #3695ff; } a.mobile-screen:hover::before { content: \"\\e98b\"; color: #7f939f; } a.mobile-screen:active::before { content: \"\\e989\"; color: #3695ff; } a.mobile-screen.active::before { content: \"\\e989\"; color: #3695ff; } a.full-screen:hover::before { content: \"\\e987\"; color: #7f939f; } a.full-screen:active::before { content: \"\\e989\"; color: #3695ff; } a.full-screen.active::before { content: \"\\e989\"; color: #3695ff; } .ui-multiselect-label-container { padding: 0px !important; width: 215px !important; height: 30px !important; } .ui-multiselect { padding: 0 !important; } .fa.fa-fw.fa-caret-down.ui-clickable { margin-top: 8px !important; } .ui-multiselect.ui-multiselect-trigger.fa { margin-top: 8px !important; } .ui-multiselect .ui-multiselect-label { padding-left: 10px !important; } .outer-container.normal { width: 800px; height: 450px; } .outer-container { display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #f2f3f8; border: 1px solid #d7dbe5; } .permission-span { display: inline-block; position: relative; top: -10px; margin-right: 4px; } .modal-header.simulation-modal-header { border-bottom: 1px solid #f4f4f4; } .toolbar { margin-bottom: 10px; } .gui-error-tip { text-align: center; } #graph-container{ border: solid 1px #d7dbe5; select{ width: auto; height: auto; } } a.full-screen.fcloud-full-screen-normal:active::before { content: \"\\e988\"; color: #3695ff; } } "],
            encapsulation: ViewEncapsulation.None,
        })
    ], ConfigureSimulationComponent);
    return ConfigureSimulationComponent;
}(ConfigureComponentBase));
export { ConfigureSimulationComponent };
